import React from 'react'
import styled from '@emotion/styled'
import * as mixins from 'view/styles/mixins'
import * as constants from 'view/styles/constants'
import { iconSet } from 'view/components/icons'
import { MultiButton } from 'view/components/buttons'

interface SendRFQPanelTitleProps {
  title: string
  isPinned: boolean
  onTogglePinned: () => unknown
}

export const PanelTitleContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 25px 15px 15px 12px;
  flex: 0 0 65px;
  ${mixins.flexCenterContentCrossAxis};
  flex-direction: column;
  background-color: white;
  color: white;
`

const Title = styled.div`
  width: 100%;
  font-family: NEXWeb;
  font-weight: ${constants.FontWeight.Normal};
  font-size: 20px;
  color: #4a4a4a;
`

const PinIcon = styled(MultiButton)<{ isPinned: boolean }>`
  position: absolute;
  top: 25px;
  right: 12px;
  svg {
    width: 22px;
    color: ${props => (props.isPinned ? constants.ACCENT_PRIMARY : constants.ACCENT_PRIMARY_3)};
  }

  &:hover {
    svg {
      color: ${constants.ACCENT_PRIMARY_1};
    }
  }
`

export class SendRFQPanelTitle extends React.Component<SendRFQPanelTitleProps> {
  render() {
    const { isPinned, onTogglePinned } = this.props
    return (
      <PanelTitleContainer>
        <Title>{this.props.title}</Title>
        <PinIcon onClick={onTogglePinned} isPinned={isPinned}>
          {isPinned ? iconSet.pinIconActive : iconSet.pinIconOff}
        </PinIcon>
      </PanelTitleContainer>
    )
  }
}
